import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Language')
export class Language {
  @JsonProperty('code', String, true) code: string = undefined;
  @JsonProperty('name', String, true) name: string = undefined;
}
